export default "__VITE_ASSET__68c638d6__"